var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.875 22.5664L25.3672 19.7773C23.9062 19.1133 22.2461 19.5781 21.25 20.7734L19.457 22.9648C16.4688 21.2383 14.0117 18.7812 12.2852 15.793L14.4766 14C15.6719 13.0039 16.1367 11.3438 15.4727 9.94922L12.6836 3.375C12.0195 1.84766 10.3594 0.984375 8.69922 1.38281L2.65625 2.77734C1.0625 3.10938 0 4.50391 0 6.16406C0 22.2344 13.0156 35.25 29.0859 35.25C30.7461 35.25 32.1406 34.1875 32.4727 32.5938L33.8672 26.5508C34.2656 24.8906 33.4023 23.2305 31.875 22.5664ZM30.7461 25.8203L29.3516 31.8633C29.3516 31.9961 29.2188 32.0625 29.0859 32.0625C14.8086 32.0625 3.12109 20.4414 3.12109 6.16406C3.12109 6.03125 3.25391 5.89844 3.38672 5.89844L9.42969 4.50391H9.49609C9.62891 4.50391 9.69531 4.57031 9.76172 4.63672L12.5508 11.1445C12.6172 11.2773 12.6172 11.4102 12.4844 11.543L9.23047 14.1328C8.69922 14.6641 8.5 15.4609 8.83203 16.125C11.0234 20.5742 14.6758 24.2266 19.125 26.418C19.7891 26.75 20.6523 26.5508 21.1172 26.0195L23.7734 22.7656C23.8398 22.6328 23.9727 22.6328 24.1055 22.6992L30.6133 25.4883C30.7461 25.5547 30.8125 25.6875 30.7461 25.8203Z",
    fill: "#212529"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.fac54cbfc8131796f55bf5efc25bb144.svg";
export { ForwardRef as ReactComponent };